import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { FileKind } from "../../../define/FileKind";
import { UIKind } from "../../../define/UIKind";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class marketPrefab extends cc.Component {

    @property({type:cc.Node,displayName:"按钮Layout"})
    btnLayout:cc.Node = null;

    onLoad(){
        this.btnLayout.children.forEach((n:cc.Node)=>{
            let line = n.getChildByName("line");
            if(line){
                line.active = false;
            } else {
                return;
            }
            n.on('touchstart',this.onTouchBtnStart,this);
            n.on('touchend',this.onTouchBtnEnd,this);
            n.on('touchcancel',this.onTouchBtnEnd,this);
        })
    }

    start () {
        O1HD.getModules().uiControlModule.hideLoading();
        utilsView.enterLayerDispose(UIKind.UILayerTag.BAZZAR, this.node);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.BAZZAR);
    }

    onTouchBtnStart(e:cc.Event.EventTouch){
        let targetNode:cc.Node = e.target;
        let line = targetNode.getChildByName("line");
        if(line){
            line.active = true;
        }
    }

    onTouchBtnEnd(e:cc.Event.EventTouch){
        let targetNode:cc.Node = e.target;
        let line = targetNode.getChildByName("line");
        if(line){
            line.active = false;
        }
    }
    private canClickFlag :boolean = true;

    async onBtnOpenPrefab(e:cc.Event.EventTouch,custom:string){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if( !this.canClickFlag) {
            return ;
        }
        this.canClickFlag = false;
        let url:string = null;
        let bundleName:BUNDLE_SMALL_NAME = null;
        switch(custom){
            case "oilField":{
                url = "prefab/oilfieldChoosePage";
                bundleName = BUNDLE_SMALL_NAME.oilfield;
                break;
            }
            case "clamShell":{
                url = "gamblerGame/gamblerGame";
                bundleName = BUNDLE_SMALL_NAME.gamblerGameBundle;
                break;
            }
            case "openOre":{
                url = "openOreGame/openOreGame";
                bundleName = BUNDLE_SMALL_NAME.openOreGameBundle;
                break;
            }
            case "openOrchard":{
                this.canClickFlag = true;
                O1HD.getModules().uiControlModule.showMessageBox("暂未开放");
                // O1HD.getModules().uiControlModule.showLoading();
                // utilsView.openPopupLayerTwo(
                //     FileKind.PrefabFilePath.OrchardSelectLayer
                //     , null
                //     , null
                //     , null
                //     , null
                //     , false
                // );

                return;
            }
            case "openKaogu":{
                url = "kaogu/kaoguMountainPage";
                bundleName = BUNDLE_SMALL_NAME.kaogu;
                break;
            }
        }
        if(url!=null){
            // 开启一个链接
            let prefab = await getOneBundleOnePrefab(bundleName,url);
            let node:cc.Node = cc.instantiate(prefab);
            node.setParent(O1HD.Canvas());
            this.canClickFlag = true;
        }else{
            console.log("#集市 打开一个玩法预制体失败");
        }
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.node.destroy();
        this.node.removeFromParent();
    }

}
